module.exports = __webpack_public_path__ + "cfc00281dbed84d75bb7cbb0caf68f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/rs6/bank2.png
// module id = 1079
// module chunks = 0